import { Grid } from 'react-flexbox-grid';
import styled from 'styled-components';

export const PageGrid = styled(Grid)`
  width: 100% !important;
  min-width: calc(100vw - 116px) !important;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/shared/CommonStyledComponents.js